import { Injectable } from '@angular/core';
import { PersonalVerificationInfoApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { PersonalVerificationInfoAction } from '../actions';

@Injectable()
export class PersonalVerificationInfoEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(PersonalVerificationInfoAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(items => PersonalVerificationInfoAction.loadItemSuccess({ items })));
      })
    );
  });
  constructor(private _apiService: PersonalVerificationInfoApiService, private _actions$: Actions, private _store: Store) {}
}
